import State from '../State';

export const COLLAPSED_KEY = 'UserRolesLegend-expanded';

const localStorage: Storage = window.localStorage;

// this migration is just a sample, it is not working in reality because
// we did not used versions from the begining
export default ({ localFlags, ...state }: State) => {
  const isLegendCollapsed = !!localStorage.getItem(COLLAPSED_KEY);
  if (isLegendCollapsed) {
    localStorage.removeItem(COLLAPSED_KEY);
  }

  return { ...state, ...{ ...localFlags, ...{ isLegendCollapsed } } };
};
